import styled from "styled-components";

export const InfoText = styled.p`
  font-weight: 400;
  display: inline-block;
`;
